import AppText from "../../_shared/components/AppText";
import { Link, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getSubProducts } from "../../../api";
import useRestList from "../../_shared/hooks/useRestList";
import "./listProducts.css";
import BackIcon from "../../_shared/components/BackIcon";
import SideMenu from "../../_shared/components/SideMenu";

function ListProducts(props) {
  const { setSplash } = props;
  useEffect(() => setSplash(false), []);
  const { id } = useParams();

  const [category, setCategory] = useState();

  const [products, setProducts] = useState();

  const [allProducts] = useRestList("/products", null, {
    category: id,
  });
  const [allCategories] = useRestList("/categories", null, {
    id: id,
  });

  useEffect(() => {
    setProducts(
      allProducts.filter(
        (x) => x?.category?.parentCategory === id || x?.category?.id === id
      )
    );
    setCategory(allCategories.find((x) => x.id === id));
  }, [allProducts, allCategories, id]);

  return (
    <div className="rootMenu">
      <SideMenu></SideMenu>
      <div className="rootContent">
        <div className="row" style={{ alignItems: "center" }}>
          <BackIcon></BackIcon>
          <div className="row" style={{ alignItems: "center", height: 30 }}>
            <AppText big bold>
              {category?.name?.it}
            </AppText>
            <AppText big> / {category?.name?.en}</AppText>
          </div>
        </div>

        <div
          class="row"
          style={{
            flexWrap: "wrap",
            marginLeft: 30,
            paddingBottom: 100,
            marginTop: 30,
          }}
        >
          {products?.map((prod) => (
            <div style={{ width: "45%", marginBottom: 30 }}>
              <Link
                to={`/product/${id}/${prod.id}`}
                style={{ color: "black", textDecorationLine: "none" }}
              >
                <img src={prod.image} style={{ width: "80%" }} alt=""></img>
                <AppText prod bold>
                  {prod.name?.it}
                </AppText>
                <div className="row">
               {console.log("prod?.category", prod?.category)}
                  {!prod?.category?.hideNameInApp && <AppText small>{prod.category?.name?.it}</AppText>}
						      {!prod?.category?.hideNameInApp &&  <AppText small>&nbsp;/ {prod.category?.name?.en}</AppText>}
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ListProducts;
